import React from 'react';
import { FormItemCard } from '../../FormItemCard';
import { actualStateOptions } from 'common/constants/publicationForm.constants';
import { Radio, Space } from 'antd';
import { Text } from '@components/common';

const ActualState = ({
  values,
  handleSelectActualState,
  currentFocus,
  handleGoBackQuestion,
  handleGoForwardQuestion,
  displayDistinctQuestion,
}) => {
  return (
    <FormItemCard
      name="actual_state"
      title="¿Cuál es el estado actual de tu proyecto?"
      subTitle={'Elige una opción'}
      isCurrent={currentFocus == 'actual_state'}
      id={'actual_state-container'}
      handleGoForwardQuestion={handleGoForwardQuestion}
      handleGoBackQuestion={handleGoBackQuestion}
      displayDistinctQuestion={displayDistinctQuestion}>
      <Radio.Group
        value={values['actual_state']?.name}
        disabled={currentFocus == 'actual_state' ? false : true}>
        <Space direction="vertical">
          {actualStateOptions?.map((item) => {
            return (
              <Radio
                onChange={() => handleSelectActualState(item)}
                value={item.name}
                key={`mult-opt-${item.id}`}>
                <Text>{item.name}</Text>
              </Radio>
            );
          })}
        </Space>
      </Radio.Group>
    </FormItemCard>
  );
};

export default ActualState;
